// @flow
import React from 'react'
import { Toggle } from 'components/toggle'
import { VideoPlayer } from 'components/videoplayer'
import './styles.scss'

export class Rendering extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      currentFrame: -1,
      isPessimistic: false
    }
    this.frameRate = 6
    this.startYear = 2022
    this.playerRef = React.createRef()
    this.videoRef = React.createRef()
    this.videoRefPessimistic = React.createRef()
    this.rewindVideo = this.rewindVideo.bind(this)
    this.syncVideos = this.syncVideos.bind(this)
    this.swapVideo = this.swapVideo.bind(this)
  }

  rewindVideo() {
    // console.log('rewindVideo:', this.props.mp4)
    this.videoRef.current.currentTime = 0
    this.videoRefPessimistic.current.currentTime = 0
  }

  syncVideos() {
    const syncPoint = this.videoRef.current.currentTime
    this.videoRefPessimistic.current.currentTime = syncPoint
    this.videoRef.current.currentTime = syncPoint
  }

  swapVideo() {
    this.syncVideos()
    this.playerRef.current.swap()
    this.setState({ isPessimistic: !this.state.isPessimistic })
    // track in google analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: `switch-scenario: ` + this.props.title
    })
  }

  componentDidMount() {}

  render() {
    return (
      <div className='ui rendering container'>
        <div className='ta text'>
          <div className='label-wrapper'>
            <Toggle
              swapVideo={this.swapVideo}
              isPessimistic={this.state.isPessimistic}
              scenario={this.props.scenario}
              title={this.props.title.toLowerCase().trim()}
            />
            <div className='swap-wrapper'>
              <div className='swap' />
              {this.props.showHint && (
                <div className='hint'>
                  <div>
                  Changer de
                    <br />
                    scénario climatique
                  </div>
                  <img
                    src={require(this.props.isMobile
                      ? '../../images/arrow-hint-small.svg'
                      : '../../images/arrow-hint.svg')}
                  />
                </div>
              )}
            </div>
          </div>
          <div className='rendering-title'>
            <span className='canton'>
              <img
                src={require('../../images/kantone/' +
                  this.props.canton +
                  '.svg')}
              />
            </span>
            <h3>{this.props.title}</h3>
          </div>
          <VideoPlayer
            ref={this.playerRef}
            isPessimistic={this.state.isPessimistic}
            mp4={this.props.mp4}
            webm={this.props.webm}
            mp4Pessimistic={this.props.mp4Pessimistic}
            webmPessimistic={this.props.webmPessimistic}
            mp4Desktop={this.props.mp4Desktop}
            webmDesktop={this.props.webmDesktop}
            mp4DesktopPessimistic={this.props.mp4DesktopPessimistic}
            webmDesktopPessimistic={this.props.webmDesktopPessimistic}
            posterImage={this.props.posterImage}
            posterImageDesktop={this.props.posterImageDesktop}
            videoRef={this.videoRef}
            videoRefPessimistic={this.videoRefPessimistic}
            rewindVideo={this.rewindVideo}
            syncVideos={this.syncVideos}
            isMobile={this.props.isMobile}
          />
        </div>
      </div>
    )
  }
}
